module["exports"] = [
  "+919##-###-####",
  "+919#########",
  "+91-9##-#######",
  "+918##-###-####",
  "+918#########",
  "+91-8##-#######",
  "+917##-###-####",
  "+917#########",
  "+91-7##-#######",
  "+916##-###-####",
  "+916#########",
  "+91-6##-#######",
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_IND/phone_number/formats.js
// module id = 2761
// module chunks = 1610